import { React, WithData } from '@gasbuddy/react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';
import { Flashcards } from '../../components/payments/flashcards';

type Props = {
  history: {
    // eslint-disable-next-line react/no-unused-prop-types
    push: Function,
  },
  // eslint-disable-next-line react/require-default-props
  match?: {
    params?: {
      // eslint-disable-next-line react/no-unused-prop-types
      date?: string
    },
  },
};

export const Batch = ({ history, match: {
  params: {
    date = moment().utcOffset('-04:00').format(),
  } = {},
} = {} }: Props) => (
  <Auth forRoles={[Role.Superuser, Role.PaymentView]}>
    <Nav>
      <div>
        <div style={{ textAlign: 'right', paddingRight: '25px' }}>
          Show
          {' '}
          <div className="inline-datepicker">
            <DatePicker
              selected={moment(date)}
              className="datetime"
              onChange={d => history.push(`/payments/batch/${moment(d).format('YYYY-MM-DD')}`)}
            />
          </div>
        </div>
        <WithData url="/payments/batch" body={{ date: moment(date).format('YYYY-MM-DD') }}>
          <Flashcards date={moment(date)} batchOnly />
        </WithData>
      </div>
    </Nav>
  </Auth>
);
